import { Select, useToast } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import TextService from "../../../ApiServices/TextService"
import AnsCommentTable from "./Table/AnsCommentTable"
import { 
    Pagination,
    usePagination,
    PaginationPage,
    PaginationNext,
    PaginationPrevious,
    PaginationPageGroup,
    PaginationContainer,
    PaginationSeparator,
} from '@ajna/pagination'


const Answer = () => {

    const [comments, setComments] = useState([])
    const [commentsTotal, setCommentsTotal] = useState()

    const outerLimit = 2
    const innerLimit = 2

    const {
        pages,
        pagesCount,
        offset,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
    } = usePagination({
        total: commentsTotal,
        limits: {
            outer: outerLimit,
            inner: innerLimit,
        },
        initialState: {
            pageSize: 10,
            isDisabled: false,
            currentPage: 1,
        },
    })

    const toast = useToast()

    const listComments = () => {
        const listComments = {
            offset,
            limit: pageSize
        }
        TextService.listComments(listComments).then(result => {

            setComments(result.data.listComments)
            setCommentsTotal(result.data.count)

        }).catch(error => {

            return toast({
                title: error.response.data.message,
                status: 'error',
                duration: 9000,
                isClosable: true,
              })

        })
    }

    useEffect(() => {

        listComments()

    }, [currentPage, pageSize,offset])

    const handlePageChange = (nextPage) => {
        setCurrentPage(nextPage);
        console.log("request new data with ->", nextPage);
    };

    const handlePageSizeChange = (event) => {
        const pageSize = Number(event.target.value);
    
        setPageSize(pageSize);
    };

  
    const handleSubmit = (commentId,text, classification, label) => {

        const answerCommentsPayload = {
            commentId,
            text: text.trim(),
            classification,
            label
        }

        TextService.answerComments(answerCommentsPayload).then(result => {
            console.log(result.data)
            listComments()
            return toast({
                title: "Updated",
                status: 'success',
                duration: 9000,
                isClosable: true,
              })

        }).catch(error => {

            return toast({
                title: error.response.data.message,
                status: 'error',
                duration: 9000,
                isClosable: true,
              })

        })
        
    }


    const handleSkip = (commentId) => {

        const skipCommentsPayload = {
            commentId
        }

        TextService.skipComments(skipCommentsPayload).then(result => {

            listComments()
            return toast({
                title: "Skipped",
                status: 'success',
                duration: 9000,
                isClosable: true,
              })

        }).catch(error => {

            return toast({
                title: error.response.data.message,
                status: 'error',
                duration: 9000,
                isClosable: true,
              })

        })
        
    }


    return (
        <div>
            <div>
            <Pagination
                pagesCount={pagesCount}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                >
                <PaginationContainer
                        align="center"
                        justify="space-between"
                        p={4}
                        w="full"
                     >
                <PaginationPrevious
                        _hover={{
                            bg: "teal.400"
                        }}
                        bg="teal.300"
                      >Previous</PaginationPrevious>
                <PaginationPageGroup
                    separator={
                        <PaginationSeparator
                            bg="teal.300"
                            fontSize="sm"
                            w={7}
                            jumpSize={11}
                        />
                    }>
                    {pages.map((page) => (
                        <PaginationPage 
                            key={`pagination_page_${page}`} 
                            page={page} 
                            w={7}
                            fontSize="sm"
                            _hover={{
                                bg: "rgb(167,241,233)"
                            }}
                            _current={{
                                bg: "rgb(167,241,233)",
                                fontSize: "sm",
                                w: 7
                            }}
                        />
                    ))}
                </PaginationPageGroup>
                    <PaginationNext
                        _hover={{
                            bg: "teal.400"
                        }}
                        bg="teal.300"
                    >Next</PaginationNext>
                    </PaginationContainer>
            </Pagination>
                <Select ml={3} value={pageSize} onChange={handlePageSizeChange} w={40}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </Select>
            <AnsCommentTable comments={comments} handleSubmit={handleSubmit} handleSkip={handleSkip}/>
            </div>
        </div>
    )
}

export default Answer;